export default __webpack_public_path__ + "static/SurojitChattoraj-13a82274daad0137cd1ce48e9ed402a2.png";